import { useSharedCheckoutContext } from '@root/components/checkout/context';

import {
  PROTECTION_PLANS,
  ProtectionPlanEnum,
  ProtectionPlanNaming,
  protectionPlanLabel,
} from '@utils/protection_plan';

export const useProtectionPlanInfo = (
  naming: ProtectionPlanNaming = 'classic',
) => {
  const {
    flowState: { values },
  } = useSharedCheckoutContext();
  const { protectionPlan } = values;

  const plan = protectionPlan ?? ProtectionPlanEnum.MINIMAL_COVERAGE;
  const value = PROTECTION_PLANS[plan];

  return {
    label: protectionPlanLabel(plan, naming),
    amount: value.cost,
  };
};
